import { createReducer, on } from '@ngrx/store';
import { initialLanguageState } from '../states/language.state';
import { setLanguage } from '../actions/language.actions';

export const languageReducer = createReducer(
  initialLanguageState,
  on(setLanguage, (state, { lang }) => ({
    ...state,
    currentLang: lang,
  }))
);
